import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import p2 from "../assets/images/vehtrack.jpg";
import doc from "../assets/images/doc.jpg";
import drive from "../assets/images/drive.png";
import battery from "../assets/images/battery.png";
import gps from "../assets/images/GPSMapDashboard.jpg";
import mis from "../assets/images/MISDashboard.JPG";
import vehicle from "../assets/images/VehicleStatus.jpg";
import tyre from "../assets/images/TyreHistoryCard.JPG";

import { Link } from "react-router-dom";


const services = [
  {
    title: "Fleet Management",
    shortDesc: "Track, maintain and monitor your fleet.",
    longDesc: "Fleet analytics, repair records, and GPS tracking in real-time.",
    demoImg: mis,
    bgImg: p2,
  },
  
  {
    title: "Driver Management",
    shortDesc: "Empower your team of drivers.",
    longDesc: "Maintain driver profiles, licenses, route history, and payroll.",
    demoImg: gps,
    bgImg: drive,
  },
  {
    title: "Battery Management",
    shortDesc: "Monitor energy health.",
    longDesc: "Battery usage charts, alerts, and replacement lifecycle.",
    demoImg: gps,
    bgImg: battery,
  },

  {
    title: "Vehicle Dues/Documents",
    shortDesc: "Automate reminders for documents.",
    longDesc: "Track insurance, pollution, permits, and dues with calendar view.",
    demoImg: vehicle,
    bgImg: doc,
  },
  {
    title: "E-Invoicing",
    shortDesc: "Simplify payments.",
    longDesc: "Auto-generate e-invoices, GST compliance, and billing reports.",
    demoImg: mis,
    bgImg: doc,
  },
  {
    title: "Transport Operations",
    shortDesc: "Streamline vehicle logistics.",
    longDesc: "Manage loading, routing, dispatch, and delivery in one dashboard.",
    demoImg: gps,
    bgImg: p2,
  },
  {
    title: "Tyre Management",
    shortDesc: "Ensure road safety with tyre logs.",
    longDesc: "Track tyre life cycle, pressure logs, rotation schedules, and replacements",
    demoImg: tyre,
    bgImg: battery,
  },
  {

    title: "GST Invoicing",
    shortDesc: "Automate billing & compliance.",
    longDesc: "Auto-generate GST-compliant invoices from trip entries, vehicle bookings, and operational modules with seamless ledger integration.  ",
    demoImg: mis,
    bgImg: doc,
  },
];

export default function Services() {
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Box sx={{ 
        // backgroundColor: "#0B0C10",8ae97d
        background  : "linear-gradient(to bottom left, #7AB2D3, #ffffff )",
        py: 10 
        }}>
      <Container>
        <Typography
          variant="h4"
          align="center"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            mb: 5,
            textTransform: "uppercase",
            letterSpacing: 1.5,
            textShadow: "1px 1px 4px rgba(0,0,0,0.4)",
          }}
        >
          Our Services
        </Typography>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.7)), url(${service.bgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#ffffff",
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: 6,
                  transition: "0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                    boxShadow: 10,
                  },
                }}
              >
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {service.shortDesc}
                  </Typography>

                  <Accordion
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                      color: "#fff",
                      "& .MuiAccordionSummary-root": {
                        color: "#E3F6F5",
                      },
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}>
                      <Typography variant="subtitle2">Learn More</Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        borderTop: "1px solid rgba(255,255,255,0.2)",
                        borderRadius: "0 0 8px 8px",
                      }}
                    >
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        {service.longDesc}
                      </Typography>
                      <Box
                        component="img"
                        src={service.demoImg}
                        alt={service.title}
                        sx={{ width: "100%", borderRadius: 2, mb: 2 }}
                      />
                      <Button
                        component={Link}
                        to="/contact"  
                        variant="contained"                                              
                        sx={{
                          backgroundColor: "#7AB2D3",
                          borderRadius: "30px",
                          fontWeight: 600,
                          "&:hover": {
                            backgroundColor: "#4A628A",
                          },
                        }}
                      >
                        Request Demo
                      </Button>
                    </AccordionDetails>
                  </Accordion>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
